/**
 * Форматирование дат на UI в отечественном формате (DD.MM.YYYY).
 * См. .cursor/skills/date-formatting/SKILL.md
 */

const EMPTY = '—';

/**
 * Парсит строку в Date. Поддерживает ISO 8601 и YYYY-MM-DD.
 */
function parseDate(value: string | null | undefined): Date | null {
  if (value == null || String(value).trim() === '') return null;
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
}

/**
 * Форматирует дату без времени: 17.03.2026.
 * Для null/undefined/пустой строки возвращает «—».
 */
export function formatDate(value: string | null | undefined): string {
  const d = parseDate(value);
  if (!d) return EMPTY;
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();
  return `${day}.${month}.${year}`;
}

/**
 * Форматирует дату и время: 17.03.2026 12:14.
 * Для null/undefined/пустой строки возвращает «—».
 */
export function formatDateTime(value: string | null | undefined): string {
  const d = parseDate(value);
  if (!d) return EMPTY;
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();
  const datePart = `${day}.${month}.${year}`;
  const hours = String(d.getHours()).padStart(2, '0');
  const minutes = String(d.getMinutes()).padStart(2, '0');
  return `${datePart} ${hours}:${minutes}`;
}
